import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    card: { marginBottom: theme.spacing(5) },
    cardContent: { display: "flex", flexDirection: "column", gap: theme.spacing(2), "&.MuiCardContent-root": { paddingTop: 0 } },
    cardTitleBox: { display: "flex", gap: theme.spacing(2), alignItems: "flex-end" },
    actionCell: { display: "flex", justifyContent: "flex-end" },
    filterActions: { display: "flex", gap: theme.spacing(2), justifyContent: "flex-end" },
}));
